import { createContext, useContext } from 'react'
import { type DiscoverStore } from '../store/DiscoverStore'

export const DiscoverContext = createContext<DiscoverStore | null>(null)

export const useDiscoverContext = () => {
  const context = useContext(DiscoverContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with DiscoverContext')

  return context
}
